import React from 'react';
import {
  PriceFilter,
  CheckBoxFilter
} from './sub-filter';

class ListFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="">
        <PriceFilter/>
        <CheckBoxFilter/>
        <CheckBoxFilter/>
        <CheckBoxFilter/>
      </section>
    );
  }
}

export default ListFilter;


// WEBPACK FOOTER //
// ./components/list-product/list-filter/ListFilter.jsx